
import React from 'react';
import "./finish.css";

const Finish = (props) => {

    const eventHandler = () => {
        props.goToStep(null, "LandingPage");
    }
    const openTab = () => {
        const newWindow = window.open('https://www.theex.com', '_blank')
        newWindow.focus();
        if (newWindow) newWindow.opener = null
    }

    return (
        <div className="Finish">
            <div className="folderContainer">

                <div className='folder'></div>
                <div className='prizesContainer'>
                    <div className='prize1'></div>
                    <div className='prize2'></div>
                    <div className='prize3'></div>
                </div>

                <div className='whiteNote'>
                    <div className='instructionNote'>
                        “Those mischievous ghosts stole all of the plushies to poke fun at Joe!! But let that be our little secret…he doesn’t need to know!”
                    </div>
                </div>
                <div>
                    <button className='finishButton' onClick={eventHandler}>Restart?</button>
                    <button className='finishButton' onClick={openTab}>Visit The Ex!</button>
                </div>
            </div>
        </div>
    );
}

export default Finish;